import axiosInstance from "auth/FetchInterceptor";
import { NOI_DUNG_THUC_HANH_API } from "constants/ApiConstant";
const practiveManagementService = {};

practiveManagementService.create = function (data) {
  return axiosInstance.post(`${NOI_DUNG_THUC_HANH_API}`, data);
};

practiveManagementService.update = function (data) {
  return axiosInstance.post(`${NOI_DUNG_THUC_HANH_API}`, data);
};

practiveManagementService.delete = function (id) {
  return axiosInstance.post(`${NOI_DUNG_THUC_HANH_API}?id=${id}`);
};

practiveManagementService.getbyid = function (id) {
  return axiosInstance.get(`${NOI_DUNG_THUC_HANH_API}?id=${id}`);
};
practiveManagementService.getall = function (id) {
  return axiosInstance.get(`${NOI_DUNG_THUC_HANH_API}/getall`);
};

export default practiveManagementService;
